import { render, staticRenderFns } from "./select-section.vue?vue&type=template&id=41c6cff3"
import script from "./select-section.vue?vue&type=script&lang=js"
export * from "./select-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports